import React from 'react';
import { connect } from 'react-redux';
import { useLifecycle } from '../../hooks/useLifecycle';
import { ReduxState } from '../../interfaces';
import BarAction from '../shared/barAction';
import * as BarButtons from '../shared/barActionButtons';
import { appRoles } from '../../core/security/const';
import { Groups, ActionButton } from '../../models';
import useUserEKS from '../../hooks/useUserEKS';
import { hasRole } from '../../libs/security/utils';

interface StateProps {
  selectedKeys: string[];
}
type IProps = StateProps;

const ActionsBar: React.FC<IProps> = (props) => {
  useLifecycle('Orders Datatable Actions');
  const { roles: userRoles } = useUserEKS();

  const hasSelectedItems: boolean =
    props.selectedKeys && props.selectedKeys.length > 0;

  const downloadRoot = BarButtons.downloadRoot();
  const downloadOptions: ActionButton[] = hasSelectedItems
    ? [BarButtons.downloadSelected(props.selectedKeys, Groups.ORDERS)]
    : [];

  const readRightsRoot = BarButtons.readRightsRoot();
  const readRightOptions =
    hasRole(userRoles, [appRoles.superuser]) && hasSelectedItems
      ? [BarButtons.readRightsSelected(props.selectedKeys, Groups.ORDERS)]
      : [];

  return (
    <div className="datatable__actions__container">
      <BarAction items={readRightOptions} root={readRightsRoot} />
      <BarAction items={downloadOptions} root={downloadRoot} />
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  selectedKeys: state.ordersState.selection.selectedKeys,
});

export default connect(mapStateToProps)(ActionsBar);
